import { HttpService } from './http.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NGXLogger } from "ngx-logger";
import { TickerUsersInGroupResponse } from '../../app-models/realTimeModels';
import { WallboardSettingsResponse, WallboardSettingsUpdateRequest } from '../../real-time/wallboard/settings/models';
import { realtimeUserGroupResponse, queueOverviewItem, queueOverviewConfig, alarmItem, agentInQueueItem, realtimeUsersInGroup, profileService, profileServiceQuality, PauseType, queueDetailsItem, Profile, AgentList, RequestTransfer, GetRequestResponse } from 'src/app/app-models/realTimeModels';

@Injectable({
  providedIn: 'root'
})

export class realTimeService {


  constructor(private http: HttpService, private logger: NGXLogger) { }

  getUserGroups(): Observable<realtimeUserGroupResponse> {
    return this.http.getFromApi(`/Realtime/UserGroups`);
  }

  public getQueueOverview(): Observable<Array<queueOverviewItem>> {
    return this.http.getFromApi('/Realtime/QueueOverview');
  }

  public getQueueOverviewConfig(): Observable<queueOverviewConfig> {
    return this.http.getFromApi('/Realtime/QueueOverview/Config');
  }

  public GetUsersInGroup(name:string): Observable<realtimeUsersInGroup[]> {
    return this.http.getFromApi(`/Realtime/GetUsersInGroup?name=${name}`);
  }

  public GetAlarmInfoForQueue(queueId: number): Observable<Array<alarmItem>> {
    return this.http.getFromApi(`/Realtime/AlarmInfoForQueue?id=${queueId}`);
  }

   public GetSystemQueueDetails(queueId: number): Observable<Array<queueOverviewItem>> {
    return this.http.getFromApi(`/Realtime/SystemQueueDetails?id=${queueId}`);
  }

  public GetAgentStatusForQueue(queueId: number): Observable<Array<agentInQueueItem>> {
    return this.http.getFromApi(`/Realtime/AgentStatusForQueue?id=${queueId}`);
  }

  public GetServerTimeWithOffset(): Observable<string> {
    return this.http.getFromApi('/Realtime/ServerTimeWithOffset');
  }

  public getQueueDetails(queueId: number, rowsReturned?: number, startingRow?: number): Observable<Array<queueDetailsItem>> {
    if (rowsReturned === undefined || rowsReturned === null) {
      rowsReturned = 100;
    }
    if (startingRow === undefined || startingRow === null) {
      startingRow = 1;
    }
    return this.http.getFromApi(`/Realtime/QueueDetails?id=${queueId}&rowsReturned=${rowsReturned}&startingRow=${startingRow}`);
  }

    public getQueueDetailsSearch(queueId: number, keyword?: string): Observable<Array<queueDetailsItem>> {
    return this.http.getFromApi(`/Realtime/SearchQueueDetails?id=${queueId}&keyword=${keyword}`);
  }

  public GetProfile(userId:number): Observable<profileService[]> {
    return this.http.getFromApi(`/Realtime/UserGroups/GetProfile?userId=${userId}`);
  }

  public GetProfileList(userId:number): Observable<Profile[]> {
    return this.http.getFromApi(`/Realtime/UserGroups/GetProfileList?userId=${userId}`);
  }

  public getPauseTypes(): Observable<PauseType[]> {
    return this.http.getFromApi('/Realtime/UserGroups/GetPauseTypes');
  }

  public SetAgentPause(userId?:number, pauseId?:number): Observable<any> {
    return this.http.postToApi(`/Realtime/UserGroups/SetUserPaused?userId=${userId}`,JSON.stringify(pauseId));
  }

  public SetUserAvailable(userId?:number): Observable<any> {
    return this.http.postToApi(`/Realtime/UserGroups/SetUserAvailable`,JSON.stringify(userId));
  }

  public SetUserLogOff(userId?:number): Observable<any> {
    return this.http.postToApi(`/Realtime/UserGroups/SetUserLogOff`,JSON.stringify(userId));
  }

  public SetUserLogOn(phoneNumber: string, userId?:number, profileId?:number, profileNumber?: number): Observable<any> {
    return this.http.postToApi(`/Realtime/UserGroups/SetUserLogOn`,JSON.stringify({ userId, profileId, profileNumber, phoneNumber }));
  }

  public RequestDelete(requestIds: number[]): Observable<any> {
    let body = JSON.stringify(requestIds);
    return this.http.postToApi(`/Realtime/DeleteRequest`,  body);
  }
  public OngoingRequestDelete(requestIds: number[]): Observable<any> {
    let body = JSON.stringify(requestIds);
    return this.http.postToApi(`/Realtime/DeleteOngoingRequests`,  body);
  }



  public GetAllAgentsForQueue(id?: number, searchString?: string): Observable<AgentList[]> {
    return this.http.getFromApi(`/Realtime/AllAgentsForQueue?id=${id}&searchString=${searchString}`);
  }

   public GetRequest(requestId?: number): Observable<GetRequestResponse> {
    return this.http.getFromApi(`/Realtime/GetRequest?requestId=${requestId}`);
  }

  public GetQueueName(id?: number): Observable<string> {
    return this.http.getFromApi(`/Realtime/QueueName?id=${id}`);
  }

  public GetWallboardSettings(): Observable<WallboardSettingsResponse> {
    return this.http.getFromApi(`/Realtime/Wallboard/Settings`);
  }
  public SaveWallboardSettings(settings: WallboardSettingsUpdateRequest): Observable<any> {
    return this.http.postToApi(`/Realtime/Wallboard/UpdateWallboardSettings`, JSON.stringify(settings));
  }
  public SetWallboardDefaultSettings(settings: WallboardSettingsUpdateRequest): Observable<any> {
    return this.http.postToApi(`/Realtime/Wallboard/DefaultSettings`, JSON.stringify(settings));
  }

  public getWallboardData(wallboardType: string, withDetails: boolean): Observable<any> {
    const params = new URLSearchParams();

    // Add parameters
    params.append('wallboardType', wallboardType);
    params.append('withDetails', withDetails.toString());

    return this.http.getFromApi(`/Realtime/Wallboard/WallboardData?${params.toString()}`);
  }

  public getWallboardProperties(): Observable<any> {
    return this.http.getFromApi(`/Realtime/Wallboard/GetWallboardProperties`);
  }



  public getTickerAgentsInfo(id?: number): Observable<any> {
    return this.http.getFromApi(`/Realtime/Ticker/AgentsInfo?id=${id}`);
  }

  public getTickerAgentInfo(id?: number,timeWindow?:number): Observable<any> {
    return this.http.getFromApi(`/Realtime/Ticker/AgentInfo?id=${id}&timeWindow=${timeWindow}`);
  }

  public getTickerServices(timeWindow?:number): Observable<any> {
    return this.http.getFromApi(`/Realtime/Ticker/Services?timeWindow=${timeWindow}`);
  }

  public getTickerQueues(timeWindow?:number): Observable<any> {
    return this.http.getFromApi(`/Realtime/Ticker/Queues?timeWindow=${timeWindow}`);
  }

  public getOngoingCallList(): Observable<any> {
    return this.http.getFromApi(`/Realtime/OngoingCallList`);
  }
   public getTickerUsergroupsEntries(timeWindow?:number): Observable<any> {
    return this.http.getFromApi(`/Realtime/Ticker/Usergroups?timeWindow=${timeWindow}`);
  }

  public getTickerUsersInGroup(userGroupName: string, timeWindow?: number): Observable<TickerUsersInGroupResponse> {
    return this.http.getFromApi(`/Realtime/Ticker/UsersInGroup?groupName=${encodeURIComponent(userGroupName)}&timeWindow=${timeWindow || 0}`);
  }

  // 1) Agent details (overview + details rows)
public GetAgentDetailsForQueue(queueId: number): Observable<{ overview: any[]; details: any[] }> {
  return this.http.getFromApi(`/Realtime/GetAgentDetailsForQueue?queueId=${queueId}`);
}

// 2) Reserved user update (for change/remove reserved agent on requests)
public ReservedUserUpdate(requestId: number, secondsFromNow: number | null, userId: number | null): Observable<any> {
  // API expects: [FromBody] long requestId, query: secondsFromNow & userId
  // secondsFromNow: -1 => remove, -2 => change (as in old app)
  return this.http.postToApi(
    `/Realtime/ReservedUserUpdate?secondsFromNow=${secondsFromNow ?? ''}&userId=${userId ?? ''}`,
    JSON.stringify(requestId)
  );
}
public getScheduledCallList(queueId: number): Observable<any> {
  return this.http.getFromApi(`/Realtime/GetScheduledCallList?queueId=${queueId}`);
}
}
